import { React, useEffect, useState } from "react";
import { apiService } from "../Axios/apiService";
import { BrowserRouter, Route, Routes, Link, useNavigate } from "react-router-dom";


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'
import { useAuthContext } from "../Hooks/useAuthContext";
import moment from "moment";

// Map
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { MapContainer, TileLayer, useMap, Marker, Popup } from 'react-leaflet'
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';

// calendar
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import interactionPlugin from "@fullcalendar/interaction" // needed for dayClick

export default function Home() {
    const { user } = useAuthContext();
    const navigate = useNavigate();

    const [projects, setProjects] = useState([]);
    const [tasks, setTasks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [events, setEvents] = useState([]);

    const DefaultIcon = L.icon({
        iconUrl: icon,
        shadowUrl: iconShadow,
        iconSize: [30, 50],
        iconAnchor: [15, 50]
    });
    L.Marker.prototype.options.icon = DefaultIcon;

    useEffect(() => {

        // Projects
        apiService("get", `projects/?status=Active`, null,
            (response) => {
                console.log("Projects:", response);
                setProjects(response);
                setLoading(false);
            },
            (error) => {
                console.log(error);
                setLoading(false);
            }
        );


        // Tasks
        const now = new Date();

        const startDate = new Date();
        startDate.setDate(now.getDate() - 7);

        const endDate = new Date();
        endDate.setDate(now.getDate() + 30);

        apiService(
            "get",
            `tasks/?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`,
            null,
            (response) => {
                console.log("Tasks:", response);
                setTasks(response);
                setLoading(false);
            },
            (error) => {
                console.log(error);
                setLoading(false);
            }
        );

    }, []); 


    

    const handleDateClick = (arg) => {
        console.log(arg.dateStr)
    }

    const handleEventClick = (clickInfo) => {
        console.log('Event clicked:', clickInfo.event)
        navigate(`/projects/view/${clickInfo.event.extendedProps.projectId}`)
    }

    function renderEventContent(eventInfo) {
        const type = eventInfo.event.extendedProps.type;

        const styleMap = {
            activeTask: { backgroundColor: "lightblue" },
            completedTask: { backgroundColor: "lightgreen" },
            anniversary: { backgroundColor: "lightgrey" }
        };

        return (
            <div style={styleMap[type]}>
                <b>{eventInfo.timeText}</b>
                <i style={{ color: "black" }}>{eventInfo.event.title}</i>
            </div>
        );
    }




    const handleDatesSet = (dateInfo) => {
        console.log("dateInfo", dateInfo);

        apiService("get", `events/?startDate=${dateInfo.start.toISOString()}&endDate=${dateInfo.end.toISOString()}`, null,
            (response) => {
                console.log("Events:", response);

                // map the response to the format FullCalendar expects
                const events = response.map(task => ({
                    title: task.projectId,
                    start: task.date,
                    allDay: true,
                    extendedProps: {
                        type: task.type, // e.g., "activetask" or "completedtask"
                        projectId: task.projectId
                    }
                }));

                console.log("Mapped Events:", events);

                setEvents(events);
            },
            (error) => {

            }
        )

    }

    const styles = {
        calendarevent_activeTask: {
            backgroundColor: "lightblue",
            color: "black"
        },
        calendarevent_completedTask: {
            backgroundColor: "lightgreen"
        },
    }


    return (
        <div className="page">
            <div className="row">
                <div className="col-7">
                    {/* Location map */}

                    <MapContainer center={[55,-3]} zoom={7} scrollWheelZoom={false} style={{ height: 500, width: '100wh' }}>
                        <TileLayer
                            attribution="Imagery &copy; <a href='https://www.mapbox.com/'>Mapbox</a>"
                            url="https://api.tiles.mapbox.com/v4/mapbox.satellite/{z}/{x}/{y}.png?access_token=pk.eyJ1IjoiaXRhZGNvbGxlY3QiLCJhIjoiY2szNXNhemdoMGx1aTNocGU3bGRwMjJpbSJ9.V7BIAIP0gFWXMzi9Uq-9QQ"
                        />
                        {projects.map((project) => {
                            if (project.farm?.latitude != null && project.farm?.longitude != null) {
                                return (
                                    <Marker
                                        key={project.id}
                                        position={[project.farm.latitude, project.farm.longitude]}
                                    >
                                        <Popup>
                                            <strong>{project.farm.name}</strong><br />
                                            {project.id} {project.title}<br />
                                            <br/>
                                            <button className="btn btn-primary btn-sm" onClick={() => { navigate(`/Projects/View/${project.id}`) }}>View Project</button>
                                        </Popup>
                                    </Marker>
                                );
                            }
                            return null;
                        })}
                    </MapContainer>



                </div>

                <div className="col-5">
                    <FullCalendar
                        plugins={[dayGridPlugin, interactionPlugin]}
                        eventContent={renderEventContent}
                        initialView="dayGridMonth"
                        events={events}
                        dateClick={handleDateClick}
                        datesSet={handleDatesSet}
                        eventClick={handleEventClick}
                        height="100%"
                    />
                </div>
            </div>


            <div className="row mt-4">
                <div className="col-7">


                    <h1>Projects <button className="btn-sm btn-primary" onClick={() => { navigate(`/Projects/Create/`) }}><FontAwesomeIcon icon={faPlus} /> Add</button> </h1>

                    


                    <table style={{ width: "100%" }}>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Farm</th>
                                <th>Project</th>
                                <th>Status</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            {projects && (projects.map((project) => {
                                return (
                                    <tr key={project.id} style={{ cursor: "pointer" }}>
                                        <td onClick={() => { navigate(`/Projects/View/${project.id}`) }}>{project.id}</td>
                                        <td>
                                            <a href="#" onClick={() => { navigate(`/Farms/View/${project.farm.id}`) }}>{project.farm.name}</a>
                                            {project.referredBy && (
                                                <span style={{ color: "#a0a0a0" }}>
                                                    {" - "}{project.referredBy}
                                                </span>
                                            )}

                                        </td>
                                        <td onClick={() => { navigate(`/Projects/View/${project.id}`) }}>{project.title} ({project.year})</td>
                                        <td onClick={() => { navigate(`/Projects/View/${project.id}`) }}>{project.status}</td>
                                       
                                    </tr>
                                )
                            }))}

                        </tbody>
                    </table>
                </div>

                <div className="col-5">
                    <h1>Upcoming Tasks</h1>

                    <table style={{ width: "100%" }}>
                        <thead>
                            <tr>
                                <th>Due Date</th>
                                <th>Project</th>
                                
                                <th>Status</th>
                                
                            </tr>
                        </thead>
                        <tbody>
                            {tasks && (tasks.map((task) => {
                                return (
                                    <tr key={task.id} style={{ cursor: "pointer" }}>
                                        <td onClick={() => { navigate(`/Projects/View/${task.projectId}`) }}>{new moment(task.date).format("DD/MM/YYYY")}</td>
                                        <td onClick={() => { navigate(`/Projects/View/${task.projectId}`) }}>{task.projectId} {task.title}</td>
                                        
                                        <td onClick={() => { navigate(`/Projects/View/${task.projectId}`) }}>{task.status}</td>
                                    </tr>
                                )
                            }))}

                        </tbody>
                    </table>
                </div>


            </div>
        </div>);
}
